<template>
  <div class="invoice-item">
    <div class="item auItem2 clearfix">
      <el-form :model="Item" ref="invoiceForm" @validate="valudateItem" :rules="rules" label-width="110px" class="userForm">
        <el-form-item label="公司名称" prop="org_name">
          <el-input v-model="Item.org_name" placeholder="" size="small"></el-input>
        </el-form-item>
        <el-form-item label="纳税人识别号" prop="org_taxpayer_reg_number">
          <el-input v-model="Item.org_taxpayer_reg_number" placeholder="" size="small"></el-input>
        </el-form-item>
        <el-form-item label="公司地址" prop="org_address">
          <el-input v-model="Item.org_address" placeholder="" size="small"></el-input>
        </el-form-item>
        <el-form-item label="公司电话" prop="org_telephone">
          <el-input v-model="Item.org_telephone" placeholder="" size="small"></el-input>
        </el-form-item>
        <el-form-item label="开户银行" prop="org_bank">
          <el-input v-model="Item.org_bank" placeholder="" size="small"></el-input>
        </el-form-item>
        <el-form-item label="银行账号" prop="org_account">
          <el-input v-model="Item.org_account" placeholder="" size="small"></el-input>
        </el-form-item>
        <el-form-item label="收票人姓名" prop="per_name">
          <el-input v-model="Item.per_name" placeholder="" size="small"></el-input>
        </el-form-item>
        <el-form-item label="收票人手机号" prop="per_telephone">
          <el-input v-model="Item.per_telephone" placeholder="" size="small"></el-input>
        </el-form-item>
        <el-form-item label="收票人地址" prop="per_address">
          <el-input v-model="Item.per_address" placeholder="" size="small"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="fr">
      <span v-if="Isprice">发票金额: ￥{{allprice}}</span>
      <a href="javascript:;" :class="'save '+ btnclass" @click="addinvoice()">{{btntext}}</a>
    </div>
  </div>
</template>

<script>
import eventBus from '../../common/eventBus.js'
export default {
  name: 'invoiceItem',
  props: ['model', 'orderIds', 'btntext', 'Isprice', 'allprice', 'btndisable'],
  data () {
    return {
      radio: '1',
      rules: {
        org_name: [
          { required: true, message: '请输入公司名称', trigger: 'blur' },
          { pattern: /^[\u4E00-\u9FA5A-Za-z0-9]+$/, message: '请输入中文、字母、数字' }
        ],
        org_taxpayer_reg_number: [
          { required: true, message: '请输入纳税人识别号', trigger: 'blur' },
          { pattern: /^[A-Za-z0-9]+$/, message: '请输入字母、数字' }
        ],
        org_address: [
          { required: true, message: '请输入公司地址', trigger: 'blur' },
          { pattern: /^[\u4E00-\u9FA5A-Za-z0-9]+$/, message: '请输入中文、字母、数字' }
        ],
        org_telephone: [
          { required: true, message: '请输入公司电话', trigger: 'blur' },
          { pattern: /^(?:(?:0\d{2,3}[- ]?[1-9]\d{6,7})|(?:[48]00[- ]?[1-9]\d{6}))$/, message: '请输入正确的公司电话' }
        ],
        org_bank: [
          { required: true, message: '请输入开户银行', trigger: 'blur' },
          { pattern: /^[\u4E00-\u9FA5A-Za-z0-9]+$/, message: '请输入中文、字母、数字' }
        ],
        org_account: [
          { required: true, message: '请输入银行账号', trigger: 'blur' },
          { pattern: /^([1-9]{1})(\d{14}|\d{18})$/, message: '请输入正确的银行账号' }
        ],
        per_name: [
          { required: true, message: '请输入收票人姓名', trigger: 'blur' },
          { pattern: /^[\u0391-\uFFE5]+$/, message: '请输入中文' }
        ],
        per_telephone: [
          { required: true, message: '请输入收票人手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号' }
        ],
        per_address: [
          { required: true, message: '请输入收票人地址', trigger: 'blur' },
          { pattern: /^[\u4E00-\u9FA5A-Za-z0-9]+$/, message: '请输入中文、字母、数字' }
        ]
      }
    }
  },
  computed: {
    Item: {
      get () {
        return this.model
      }
    },
    btnclass: {
      get () {
        return this.btndisable || 'disable'
      },
      set () {

      }
    }
  },
  methods: {
    addinvoice () {
      this.$refs['invoiceForm'].validate((valid) => {
        if (valid) {
          // this.$emit('alertout')
          let invoice = JSON.stringify(this.Item)
          // 发票申请
          if (this.Isprice) {
            let queryParam = {
              invoiceId: this.Item.invoice_number,
              orderIds: this.orderIds
            }
            this.sapost('/dmc/account/applyInvoice', queryParam, r => {
              let { retMsg, retCode } = r.data
              if (retCode === '0') {
                this.$message.success(retMsg)
                this.$refs.invoiceForm.resetFields()
                this.$emit('applyInvoiceSuccess', invoice)
              } else {
                if (retMsg === '用户未登录！') {
                  eventBus.$emit('logout')
                }
                this.$message.warning(retMsg)
              }
            })
          } else {
            // 发票新增
            this.$http({
              method: 'post',
              url: '/dmc/account/saveInvoice',
              headers: {
                'Content-Type': 'application/json;charset=UTF-8'
              },
              data: invoice
            }).then(r => {
              let { retMsg, retCode } = r.data
              if (retCode === '0') {
                this.$message.success(retMsg)
                this.$refs.invoiceForm.resetFields()
                this.$emit('addInvoiceSuccess', invoice)
              } else {
                if (retMsg === '用户未登录！') {
                  eventBus.$emit('logout')
                }
                this.$message.warning(retMsg)
              }
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 任一一个表单被验证时发生的事件
    valudateItem (val) {
      if (this.Item.name && this.Item.nsrsbh && this.Item.address && this.Item.phone && this.Item.khbank && this.Item.bankhm && this.Item.sprname && this.Item.sprphone && this.Item.spraddress) {
        this.$emit('updatebtn', 'tbn')
      } else {
        this.btnclass = 'disable'
      }
    }
  }
}
</script>

<style lang="less">
.invoice-item{
  position: relative;
  .el-form-item{
    float: left;
    width: 48%;
    padding-right: 2%;
  }
  .fr{
    text-align: right;
    margin-top: -35px;
    a.save{
      background-color: #f14242;
      color: #fbdfdd;
      display: inline-block;
      padding: 0 15px;
      line-height: 28px;
      height: 28px;
      cursor: pointer;
      margin-left: 10px;
    }
    a.disable{
      background-color: #edf1f2;
      color: #bcbcbc;
      display: inline-block;
      padding: 0 15px;
      line-height: 28px;
      height: 28px;
      cursor: pointer;
      margin-left: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/invoice/invoiceItem.vue